export const SAVE_ASSET = 'SAVE_ASSET';
export const PREFIX = 'DEV_PORTAL_';

export const INIT_REF = `${PREFIX}INIT_REF`;
export const REMOVE_REF = `${PREFIX}REMOVE_REF`;
export const REMOVE_REFS = `${PREFIX}REMOVE_REFS`;
export const UPDATE_CHANGE_ID = `${PREFIX}UPDATE_CHANGE_ID`;
export const UPDATE_REQUIRED_CHANGES = `${PREFIX}UPDATE_REQUIRED_CHANGES`;
export const ADD_PENDING_CHANGES = `${PREFIX}ADD_PENDING_CHANGES`;
export const CLEAR_PENDING_CHANGE = `${PREFIX}CLEAR_PENDING_CHANGE`;
export const CLEAR_PENDING_CHANGES = `${PREFIX}CLEAR_PENDING_CHANGES`;

export const FETCH_APIKEY = `${PREFIX}FETCH_APIKEY`;
export const GENERATE_APIKEY = `${PREFIX}GENERATE_APIKEY`;

export const LOGIN = `${PREFIX}LOGIN`;
export const LOGOUT = `${PREFIX}LOGOUT`;
export const RELOAD = `${PREFIX}RELOAD`;
export const UPDATE_CURRENT_USER = `${PREFIX}UPDATE_CURRENT_USER`;

export const FETCH_ORGANIZATIONS = `${PREFIX}FETCH_ORGS`;

export const SEARCH = `${PREFIX}SEARCH`;

export const FETCH_ASSET = `${PREFIX}FETCH_ASSET`;
export const RESET_ASSET = `${PREFIX}RESET_ASSET`;

export const FETCH_ASSETS = `${PREFIX}FETCH_ASSETS`;

export const FETCH_EVENTS = `${PREFIX}FETCH_EVENTS`;
export const RESET_EVENTS = `${PREFIX}RESET_EVENTS`;

export const FETCH_ASSETS_FOR_AUTOCOMPLETE = `${PREFIX}FETCH_ASSETS_FOR_AUTOCOMPLETE`;
export const RESET_ASSETS_FOR_AUTOCOMPLETE = `${PREFIX}RESET_ASSETS_FOR_AUTOCOMPLETE`;

export const FETCH_ACTIVITIES = `${PREFIX}FETCH_ACTIVITIES`;

export const SAVE_PROGRESS_START = `${PREFIX}SAVE_PROGRESS_START`;
export const SAVE_PROGRESS_STEP = `${PREFIX}SAVE_PROGRESS_STEP`;
export const SAVE_PROGRESS_CLEAR = `${PREFIX}SAVE_PROGRESS_CLEAR`;

export const SAVE_ADD_ERROR = `${PREFIX}SAVE_ADD_ERROR`;
export const SAVE_CLEAR_ERRORS = `${PREFIX}SAVE_CLEAR_ERRORS`;

export const VALIDATION_ADD_ERROR = `${PREFIX}VALIDATION_ADD_ERROR`;
export const VALIDATION_CLEAR_ERRORS = `${PREFIX}VALIDATION_CLEAR_ERRORS`;

export const USER_SEARCH_FETCH = `${PREFIX}USER_SEARCH_FETCH`;
export const USER_SEARCH_UPDATE = `${PREFIX}USER_SEARCH_UPDATE`;
export const USER_SEARCH_ADD_ERROR = `${PREFIX}USER_SEARCH_ADD_ERROR`;
export const USER_SEARCH_CLEAR_ERROR = `${PREFIX}USER_SEARCH_CLEAR_ERROR`;

export const FETCH_ACCOUNT = `${PREFIX}FETCH_ACCOUNT`;
export const ENABLE_DEVELOPER_ACCESS = `${PREFIX}ENABLE_DEVELOPER_ACCESS`;
export const UPDATE_ACCOUNT = `${PREFIX}UPDATE_ACCOUNT`;
